module.exports = __webpack_public_path__ + "static/media/business.ea88ad44.svg";